<template lang="pug">
  v-container
    v-row
      v-col
        illustration-state(
          :illustration="illustration"
          :height="300"
          title="Vous n'avez aucune notification")
</template>

<script>
import { page } from '@iez/core'
import { mdiBell } from '@mdi/js'
import illustration from '@iez/illustrations/Notify'
import IllustrationState from '@iez/components/illustration-state/'

const route = {
  name: 'Notifications',
  path: '/notifications'
}

page.bottomNavigation.add({
  route,
  icon: mdiBell,
  position: 3,
  size: 32
})

export default {
  ...route,

  components: {
    IllustrationState
  },

  setup () {
    return {
      illustration
    }
  }
}
</script>
